export default {
    encoding: [
        {
            name: 'featureId',
            type: '[string]',
            desc:
                'Specify the dataSource field that should be used to identify each area in the Choropleth map.',
            isRequired: 'false',
        },
        {
            name: 'value',
            type: '[number]',
            desc: 'Specify the dataSource field that indicates the value of each area in the Choropleth map.',
            isRequired: 'false',
        },
        {
            name: 'fill',
            type: '[string]',
            desc:
                'Specify the dataSource field that should be used to select the color of each area in the Choropleth Map.',
            isRequired: 'false',
        },
    ],
    events: [
        {
            name: 'feature.hover',
            desc: 'trigger when user hovers over a feature or leaves',
        },
        {
            name: 'map.click',
            desc: 'trigger when user clicks on a map',
        },
    ],
};
